module.exports = __webpack_public_path__ + "static/media/hm.fdc04e21.svg";